export default __webpack_public_path__ + "static/media/academicPlanning.8f8520bb.png";